//Core
import React from "react"

//Components
import ListWithBullet from "../ListWithBullet"

//Helpers
import { classes } from "../../helpers/classname"

//Style
import style from "./style.module.scss"

const {
  Grid,
  Container,
  Wrapper,
  Title,
  ImageContainer,
  Card,
  CardTitle,
  ListWrapper,
  Subtitle,
} = style

const CardComponent = ({
  title,
  titleBefore,
  list,
  titleColor,
  bulletColor,
  cardImage,
  cardTitle,
}) => {
  return (
    <div className={classes(Container, Grid)}>
      <h2 className={Title} style={{ color: titleColor }}>
        {title}
        <span className={Subtitle}>{titleBefore}</span>
      </h2>
      <div className={classes(Wrapper, Grid)}>
        <div className={Card}>
          <div className={CardTitle}>{cardTitle}</div>
          <img
            src={cardImage}
            className={ImageContainer}
            alt={cardTitle + "| Таскомбанк"}
          ></img>
        </div>
        <div className={ListWrapper}>
          <ListWithBullet list={list} color={bulletColor}></ListWithBullet>
        </div>
      </div>
    </div>
  )
}

export default CardComponent
